module.exports = __webpack_public_path__ + "img/24_39.4bbe9065.png";